"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = _interopRequireDefault(require("../styles"));
var _tokens = require("../styles/tokens");
var styles = {
  root: {
    padding: "0 " + _tokens.spacing40,
    alignItems: 'center',
    margin: 'inherit',
    height: _tokens.sizingXxLarge1,
    '& svg': {
      height: _tokens.sizingXxLarge1
    },
    '& .eds-header-bar-logo': {
      // in our examples, we seem to use a custom `svg` element for the Logo
      //   instead of our Logo component
      // this helper class is going to make sure each variant of the logo is consistent,
      //   whether it is the Logo component or a custom svg
      // logo root class has height, of 4rem, svg gets height from this and width
      height: _tokens.sizingXxLarge1,
      display: 'inline-block',
      '& svg': {
        width: '5.625rem' // this width matches the HeaderBar svg style
      }
    }
  }
};
var HeaderBarLogo = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var classes = props.classes,
    children = props.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root,
    ref: ref
  }, children);
});
HeaderBarLogo.displayName = 'HeaderBarLogo';
HeaderBarLogo.propTypes = {
  /**  The content of the component. This component's children might be an image or brand name. */
  children: _propTypes.default.node.isRequired,
  /** Useful to extend the style applied to components. */
  classes: _propTypes.default.object
};
var _default = exports.default = (0, _styles.default)(styles)(HeaderBarLogo);